module.exports = __webpack_public_path__ + "static/media/icon-white-red-Benchmark.13983b35.13983b35.svg";